<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <div class="clearfix">
            <h1 class="float-left display-2 mr-4">500</h1>
            <h4 class="pt-3">
              Ops! Ocorreu algum problema na comunicação com o servidor.
            </h4>

            <p>Por segurança, pode ser necessário que voce realize um novo login.</p>
            
            <p class="text-muted">
              Voltar para a <router-link :to="{ name: 'index'} ">Dashboard</router-link>
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page500'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/500.vue